/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface ProductListUpdateRequest
 */
export interface ProductListUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductListUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListUpdateRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListUpdateRequest
     */
    externalCode?: string;
    /**
     * 
     * @type {Status}
     * @memberof ProductListUpdateRequest
     */
    status?: Status;
}

/**
 * Check if a given object implements the ProductListUpdateRequest interface.
 */
// @ts-ignore
export function instanceOfProductListUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListUpdateRequestFromJSON(json: any): ProductListUpdateRequest {
    return ProductListUpdateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListUpdateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'status': !exists(json, 'status') ? undefined : StatusFromJSON(json['status']),
    };
}

// @ts-ignore
export function ProductListUpdateRequestToJSON(value?: ProductListUpdateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'external_code': value.externalCode,
        'status': StatusToJSON(value.status),
    };
}

